import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaBell } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import NotificationBox from '../NotificationBox/NotificationBox';

function NotificationBell() {
  const notificationCount = useSelector((state) => state?.notification?.notificationCount);
  const [showNotification, setShowNotification] = useState(false);

  return (
    <div className="notification-container">
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 150, hide: 50 }}
        overlay={<Tooltip>Notifications</Tooltip>}>
        <div className="icon-button " onClick={() => setShowNotification(!showNotification)}>
          {Boolean(notificationCount) && (
            <span className="notification-count">{notificationCount}</span>
          )}
          <FaBell />
        </div>
      </OverlayTrigger>
      {showNotification && <NotificationBox />}
    </div>
  );
}

export default NotificationBell;
